// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"79":"84e18166","133":"fad2ca84","169":"42c8af86","195":"4ca52c33","407":"97b5f571","487":"93e42840","555":"e89950bc","696":"317a3f66","771":"ae0b52b6","896":"74881c6c"}[chunkId] + ".chunk.css";
};